<template>
  <DialogLayout
    title="詳細検索"
    :visible.sync="dialogVisible"
    width="65em"
    @open="open"
    class="detail-search-dialog"
  >
    <template #form>
      <FlightDataForm
        ref="flightDataForm"
        v-model="flightDataForm"
        label-width="10em"
        formMode="search"
        :autocomplete-registration-symbol-set="autocompleteRegistrationSymbolSet"
        :autocomplete-model-code-set="autocompleteModelCodeSet"
        :autocomplete-customer-code-set="autocompleteCustomerCodeSet"
        :autocomplete-airport-code-set="autocompleteAirportCodeSet"
      />
    </template>
    <template #footer>
      <SearchDialogFooter
        @clear="clickClear"
        @search="clickSearch"
      />
    </template>
 </DialogLayout>
</template>

<script>
import DialogLayout from '@/components/templates/DialogLayout.vue'
import FlightDataForm from '@/components/organisms/dialog/data/FlightDataForm.vue'
import SearchDialogFooter from '@/components/organisms/dialog/SearchDialogFooter.vue'

export default {
  components: {
    DialogLayout,
    FlightDataForm,
    SearchDialogFooter
  },
  props: {
    model: Object,
    autocompleteRegistrationSymbolSet: {
      type: Array,
      default: () => ([])
    },
    autocompleteModelCodeSet: {
      type: Array,
      default: () => ([])
    },
    autocompleteCustomerCodeSet: {
      type: Array,
      default: () => ([])
    },
    autocompleteAirportCodeSet: {
      type: Array,
      default: () => ([])
    },
    visible: Boolean
  },
  data () {
    return {
      flightDataForm: {
        billing_ym: this.getDefaultBillingYm(),
        action_type: undefined,
        callsign: undefined,
        route_code: undefined,
        mpdel_code: undefined,
        operator_code: undefined,
        registration_symbol: undefined,
        cargo_passenger_type: undefined,
        flight_purpose_code: undefined,
        departure_airport_code: undefined,
        destination_airport_code: undefined,
        actual_time_arrival: undefined,
        actual_time_departure_from: undefined,
        actual_time_departure_to: undefined,
        irregular: undefined,
        divert_airport_code: undefined
      }
    }
  },
  computed: {
    dialogVisible: {
      get () {
        return this.visible
      },
      set (value) {
        this.$emit('update:visible', value)
      }
    }
  },
  mounted () {
  },
  methods: {
    clickClear () {
      this.$refs.flightDataForm.clearFields()
    },
    clickSearch () {
      this.$refs.flightDataForm.validate()
        .then((valid) => {
          sessionStorage.setItem('flightDataSearchCond', JSON.stringify(this.flightDataForm))
          this.dialogVisible = false
          this.$emit('search', this.flightDataForm)
        })
    },
    open () {
      const searchCond = JSON.parse(sessionStorage.getItem('flightDataSearchCond'))
      this.$nextTick(() => {
        this.$refs.flightDataForm.clearFields()
        if (searchCond) {
          Object.keys(this.flightDataForm).forEach((x) => {
            this.$set(this.flightDataForm, x, searchCond[x])
          })
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.detail-search-dialog {
  ::v-deep .el-form-item {
    &.remarks {
      display: none;
    }
  }
}
</style>
